<svg width="0" height="0" class="cg3-icon-sprite">
    <symbol id="wk-icon-active-member" viewBox="0 0 14 14">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.00013 8.86655C9.33346 8.86655 11.2001 6.99989 11.2001 4.66655C11.2001 2.33322 9.33346 0.466553 7.00013 0.466553C4.6668 0.466553 2.80013 2.33322 2.80013 4.66655C2.80013 6.99989 4.6668 8.86655 7.00013 8.86655ZM10.7335 8.16655C9.80013 9.15822 8.45846 9.79989 7.00013 9.79989C5.5418 9.79989 4.20013 9.15822 3.2668 8.16655C1.57513 9.33322 0.466797 11.3166 0.466797 13.5332H13.5335C13.5335 11.3166 12.4251 9.33322 10.7335 8.16655Z"
        />
    </symbol>
</svg>
